import React from "react";
import AuthForm from "./Form";

const Login = () => {
  return <AuthForm type="login" />;
};

export default Login;
